angular.module('inspinia').directive('baseCheckbox', () => {
  return {
    restrict: 'E',
    scope: {
      name: '@',
      ngTrueValue: '@',
      ngFalseValue: '@',
      ngChecked: '@',
      onClick: '&',
      ngDisabled: '=?',
      ngModel: '=',
      type: '@',
      value: '@',
      ngValue: '@',
      indeterminate: '=?',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/base_checkbox.html?${new Date().getTime()}`,
    link($scope, element) {
      $scope.ngDisabled = $scope.ngDisabled || false;

      /**
       * チェックボックスの種別
       */
      const baseCheckboxTypes = () => {
        const prefix = 'anglrC-checkbox';
        $scope.checkboxType = '';
        $scope.iconType = '';

        if ($scope.type === 'alert') {
          $scope.checkboxType = `${prefix}--alert`;
          $scope.iconType = `${prefix}_icon--alert`;
        } else if ($scope.ngDisabled) {
          $scope.checkboxType = `${prefix}--disabled`;
        }
      };
      baseCheckboxTypes();

      /**
       * クリックイベントの発火
       */
      $scope.onClickBaseCheckbox = () => {
        const setValue = () => {
          if (!$scope.ngDisabled) $scope.onClick();
        };
        setTimeout(setValue, 100);
      };

      /**
       * ng-disabledを監視して、クラスを動的に変更する
       */
      $scope.$watch('ngDisabled', (newVal, oldVal) => {
        if (newVal !== oldVal) {
          $scope.ngDisabled = newVal;
          baseCheckboxTypes();
        }
      });

      $scope.$watch('indeterminate', (newVal) => {
        element.find('input')[0].indeterminate = newVal;
      });
    },
  };
});
